import { Icon } from "native-base";

export default Icon;